import { render, staticRenderFns } from "./TvCard.vue?vue&type=template&id=353695fe"
import script from "./TvCard.vue?vue&type=script&lang=js"
export * from "./TvCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports